import { render, staticRenderFns } from "./messageController.vue?vue&type=template&id=75a2404d&scoped=true&"
import script from "./messageController.vue?vue&type=script&lang=js&"
export * from "./messageController.vue?vue&type=script&lang=js&"
import style0 from "./messageController.vue?vue&type=style&index=0&id=75a2404d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a2404d",
  null
  
)

export default component.exports